import React from 'react';

const LocationDetails = () => {
    return <div className='location-style'>
        <a href="https://www.alittlewhitechapel.com/" target="_blank" rel="noreferrer"><h4>A Little White Chapel</h4></a>
        <p>1301 S Las Vegas Blvd, Las Vegas, NV 89104</p>
    </div>
};

export default LocationDetails;